import CloseIcon from "@mui/icons-material/Close";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import SearchIcon from "@mui/icons-material/Search";
import TuneIcon from "@mui/icons-material/Tune";
import {
  Avatar,
  Badge,
  Box,
  Button,
  Chip,
  Divider,
  Fade,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import OrderFilters from "../../components/order-filters/OrderFilters";
import Iconify from "../../components/iconify/Iconify";
import OrderDetailsDrawer from "../../components/order-details-drawer/OrderDetailsDrawer";
import moment from "moment";
import { getOrderHistory } from "../../reduxStore/slices/orderHistorySlice";
import { useDispatch, useSelector } from "react-redux";
import { useNotify } from "../../utils/snackbarUtils";
import { formatCurrency } from "../../utils/currency";
import HistoryEmptyState from "./HistoryEmptyState";

const statusColors = {
  Ready: { label: "Ready", color: "success" },
  "In Progress": { label: "In Progress", color: "warning" },
  Completed: { label: "Completed", color: "default" },
};

const orderHistory = {
  "2025-08-18": [
    {
      id: "925",
      table: "A4",
      name: "Ariel Hikmat",
      type: "Dine In",
      status: "Ready",
      statusNote: "Ready to serve",
      date: "Wed, July 12, 2023",
      time: "06:12 PM",
      items: [
        {
          name: "Smoked Salmon Bagel with Extra Cream Cheese",
          qty: 1,
          price: 16.99,
        },
        { name: "Smoked Salmon Bagel", qty: 1, price: 18.49 },
        { name: "Belgian Waffles", qty: 2, price: 38.98 },
        { name: "Classic Lemonade", qty: 1, price: 12.49 },
      ],
      total: 87.34,
    },
    {
      id: "921",
      table: "B2",
      name: "Denis Freeman",
      type: "Dine In",
      status: "In Progress",
      statusNote: "Cooking Now",
      date: "Wed, July 12, 2023",
      time: "06:18 PM",
      items: [
        { name: "Classic Cheeseburger", qty: 1, price: 10.99 },
        { name: "Fish and Chips", qty: 2, price: 34.0 },
        { name: "Greek Gyro Plate", qty: 1, price: 13.99 },
      ],
      total: 57.87,
    },
    {
      id: "912",
      table: "A9",
      name: "Maja Becker",
      type: "Dine In",
      status: "Completed",
      statusNote: "Waiting For Payment",
      date: "Wed, July 12, 2023",
      time: "05:32 PM",
      items: [
        { name: "Feta Stuffed Mushrooms", qty: 1, price: 18.99 },
        { name: "Lobster Ravioli", qty: 1, price: 17.99 },
        { name: "Thai Coconut Curry", qty: 2, price: 28.98 },
        { name: "Belgian Waffles", qty: 2, price: 25.98 },
      ],
      total: 98.34,
    },
  ],
  "2025-08-17": [
    {
      id: "912",
      table: "A9",
      name: "Maja Becker",
      type: "Dine In",
      status: "Completed",
      statusNote: "Waiting For Payment",
      date: "Wed, July 12, 2023",
      time: "05:32 PM",
      items: [
        { name: "Feta Stuffed Mushrooms", qty: 1, price: 18.99 },
        { name: "Lobster Ravioli", qty: 1, price: 17.99 },
        { name: "Thai Coconut Curry", qty: 2, price: 28.98 },
        { name: "Belgian Waffles", qty: 2, price: 25.98 },
      ],
      total: 98.34,
    },
    {
      id: "912",
      table: "A9",
      name: "Maja Becker",
      type: "Dine In",
      status: "Completed",
      statusNote: "Waiting For Payment",
      date: "Wed, July 12, 2023",
      time: "05:32 PM",
      items: [
        { name: "Feta Stuffed Mushrooms", qty: 1, price: 18.99 },
        { name: "Lobster Ravioli", qty: 1, price: 17.99 },
        { name: "Thai Coconut Curry", qty: 2, price: 28.98 },
        { name: "Belgian Waffles", qty: 2, price: 25.98 },
      ],
      total: 98.34,
    },
    {
      id: "912",
      table: "A9",
      name: "Maja Becker",
      type: "Dine In",
      status: "Completed",
      statusNote: "Waiting For Payment",
      date: "Wed, July 12, 2023",
      time: "05:32 PM",
      items: [
        { name: "Feta Stuffed Mushrooms", qty: 1, price: 18.99 },
        { name: "Lobster Ravioli", qty: 1, price: 17.99 },
        { name: "Thai Coconut Curry", qty: 2, price: 28.98 },
        { name: "Belgian Waffles", qty: 2, price: 25.98 },
      ],
      total: 98.34,
    },
    {
      id: "912",
      table: "A9",
      name: "Maja Becker",
      type: "Dine In",
      status: "Completed",
      statusNote: "Waiting For Payment",
      date: "Wed, July 12, 2023",
      time: "05:32 PM",
      items: [
        { name: "Feta Stuffed Mushrooms", qty: 1, price: 18.99 },
        { name: "Lobster Ravioli", qty: 1, price: 17.99 },
        { name: "Thai Coconut Curry", qty: 2, price: 28.98 },
        { name: "Belgian Waffles", qty: 2, price: 25.98 },
      ],
      total: 98.34,
    },
  ],
};

const typeColors = {
  "Dine In": "success",
  Takeaway: "warning",
  Delivery: "info",
};

const formatDate = (dateStr) => moment(dateStr).format("MMM DD, YYYY");

export default function OrderHistory() {
  const { showSuccess, handleApiError, showError } = useNotify();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { list: orderList, loading: isLoading } = useSelector(
    (state) => state.orderHistory,
  );
  const storeId = user?.storeId;

  const [filter, setFilter] = useState("last7");
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeFiltersCount, setActiveFiltersCount] = useState(0);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [isOrderDetailsDrawerOpen, setIsOrderDetailsDrawerOpen] =
    useState(false);

  const handleCloseOrderDetailsDrawer = () => {
    setIsOrderDetailsDrawerOpen(false);
  };

  const handleOrderDetailsDrawer = () => {
    setIsOrderDetailsDrawerOpen(true);
  };

  const fetchOrderHistory = async () => {
    const startDate = "2026-01-20";
    const endDate = moment().format("YYYY-MM-DD");
    const offset = 0;
    const limit = 5;

    try {
      await dispatch(
        getOrderHistory({ storeId, startDate, endDate, offset, limit }),
      ).unwrap();
    } catch (err) {
      handleApiError(err);
    }
  };

  // Fetch stats on mount and when storeId changes
  useEffect(() => {
    if (storeId) {
      fetchOrderHistory();
    }
  }, [storeId, dispatch]);

  console.log("Order History:", orderList);

  // Drawer Filters
  const [filters, setFilters] = useState({
    status: {
      ready: true,
      inProgress: true,
      completed: true,
      cancelled: false,
    },
    orderType: { dineIn: true, delivery: true, takeAway: true },
    diningArea: {
      garden: false,
      hall: false,
      rooftop: false,
      privateRoom: false,
    },
    paymentStatus: { paid: false, unpaid: false, partial: false },
  });

  // Applied filters state
  const [appliedFilters, setAppliedFilters] = useState(filters);

  const handleClear = () => {
    setFilters({
      status: {
        ready: false,
        inProgress: false,
        completed: false,
        cancelled: false,
      },
      orderType: { dineIn: false, delivery: false, takeAway: false },
      diningArea: {
        garden: false,
        hall: false,
        rooftop: false,
        privateRoom: false,
      },
      paymentStatus: { paid: false, unpaid: false, partial: false },
    });
  };

  const handleApply = () => {
    setAppliedFilters(filters);
    setOpenDrawer(false);
  };

  return (
    <Box p={4}>
      {/* Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Typography variant="h5" fontWeight="bold">
          Order History
        </Typography>

        <Box display="flex" alignItems="center" gap={2}>
          <Tooltip title={"Refresh"}>
            <IconButton onClick={fetchOrderHistory}>
              <RefreshOutlinedIcon />
            </IconButton>
          </Tooltip>
          {/* Search */}
          {searchOpen ? (
            <Fade in={searchOpen}>
              <Box display="flex" alignItems="center" gap={1}>
                <TextField
                  size="small"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Search by order ID"
                  sx={{ width: 250, bgcolor: "#fff", borderRadius: 2 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                <IconButton
                  onClick={() => {
                    setSearchOpen(false);
                    setSearchTerm("");
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </Fade>
          ) : (
            <Tooltip title={"Search"}>
              <IconButton onClick={() => setSearchOpen(true)}>
                <SearchIcon />
              </IconButton>
            </Tooltip>
          )}

          {/* Filter */}
          <Select
            size="small"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          >
            <MenuItem value="today">Today</MenuItem>
            <MenuItem value="yesterday">Yesterday</MenuItem>
            <MenuItem value="last7">Last 7 days</MenuItem>
            <MenuItem value="last28">Last 28 days</MenuItem>
            <MenuItem value="last30">Last 30 days</MenuItem>
            <MenuItem value="thisWeek">This week (Sun - Today)</MenuItem>
            <MenuItem value="lastWeek">Last week (Sun - Sat)</MenuItem>
            <MenuItem value="last90">Last 90 days</MenuItem>
            <MenuItem value="last12m">Last 12 months</MenuItem>
            <MenuItem value="thisYear">This year (Jan - Today)</MenuItem>
            <MenuItem value="lastYear">Last calender year</MenuItem>
            <MenuItem value="custom">Custom</MenuItem>
          </Select>
          <Tooltip title={"Filter"}>
            <Badge
              badgeContent={activeFiltersCount > 0 ? activeFiltersCount : null}
              color="primary"
            >
              <IconButton onClick={() => setOpenDrawer(true)}>
                <TuneIcon />
              </IconButton>
            </Badge>
          </Tooltip>
        </Box>
      </Box>

      {/* Orders Grouped by Date */}
      {orderList.length !== 0 && (
        <Box>
          {orderList.map((allOrders) => (
            <Box
              key={allOrders.order_date}
              mb={4}
              maxWidth="900px"
              margin="0 auto"
            >
              <Box
                sx={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 1,
                }}
              >
                <Typography variant="h6" fontWeight="700">
                  {formatDate(allOrders.order_date)}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    gap: "30px",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ textAlign: "center" }}>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ fontSize: "12px", mb: 0.5 }}
                    >
                      Total Orders
                    </Typography>
                    <Typography variant="h6" fontWeight="700">
                      {allOrders.total_orders}
                    </Typography>
                  </Box>
                  <Divider orientation="vertical" sx={{ height: "40px" }} />
                  <Box sx={{ textAlign: "center" }}>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ fontSize: "12px", mb: 0.5 }}
                    >
                      Total Sales
                    </Typography>
                    <Typography
                      variant="h6"
                      fontWeight="700"
                      sx={{ color: "rgb(0, 171, 85)" }}
                    >
                      {formatCurrency(allOrders.total_amount)}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <List
                sx={{
                  width: "100%",
                  bgcolor: "background.paper",
                  borderRadius: "10px",
                }}
              >
                {allOrders.orders.map((order, idx) => (
                  <React.Fragment key={order.order_uid}>
                    <ListItem
                      alignItems="flex-start"
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box display="flex" alignItems="center" gap={1.5}>
                        <ListItemAvatar>
                          <Avatar
                            variant="rounded"
                            sx={{ bgcolor: "grey.800" }}
                          >
                            {/* {order.table} */} T5
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <Box display="flex" alignItems="center" gap={1}>
                              <Typography variant="subtitle1" fontWeight={600}>
                                {/* #{order.id} / {order.type} */} #
                                {order.order_number} / Dine In
                              </Typography>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "8px",
                                }}
                              >
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  style={{
                                    background: "rgb(0, 171, 85)",
                                    color: "#fff",
                                    fontSize: "12px",
                                    borderRadius: "10px",
                                    padding: "2px 5px",
                                    fontWeight: 600,
                                  }}
                                >
                                  10 min
                                </Typography>
                                <Chip
                                  label={statusColors[order.status]?.label}
                                  color={statusColors[order.status]?.color}
                                  variant="outlined"
                                  size="small"
                                  sx={{ fontWeight: 500 }}
                                />
                              </Box>
                            </Box>
                          }
                          secondary={
                            <>
                              <Box
                                display="flex"
                                alignItems="center"
                                gap="10px"
                              >
                                <Chip label="Rooftop" size="small" />
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  • Ready to serve
                                </Typography>
                              </Box>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                {/* {order.date} • {order.time} */} Wed, July
                                12, 2023 • 06:12 PM
                              </Typography>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{ fontSize: "12px", paddingBottom: "4px" }}
                              >
                                {/* Cust Name: {order.name} */} Cust Name: Ariel
                                Hikmat
                              </Typography>
                            </>
                          }
                        />
                      </Box>

                      {/* Right side (Qty + Total + Buttons) */}
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="flex-end"
                        gap={1}
                      >
                        <Typography variant="body2" color="text.secondary">
                          Qty: {order.quantity} &nbsp; | &nbsp; Total Amount:{" "}
                          <strong>{formatCurrency(order.total_amount)}</strong>
                        </Typography>

                        <Box display="flex" gap={1}>
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={handleOrderDetailsDrawer}
                          >
                            See Details
                          </Button>
                          <Button
                            variant="contained"
                            size="small"
                            color="secondary"
                            startIcon={<Iconify icon="mdi:printer" />}
                          >
                            Reprint
                          </Button>
                        </Box>
                      </Box>
                    </ListItem>
                    {idx !== allOrders.orders.length - 1 && (
                      <Divider component="li" />
                    )}
                  </React.Fragment>
                ))}
              </List>
            </Box>
          ))}
        </Box>
      )}

      {orderList.length === 0 && !isLoading && (
        <HistoryEmptyState
          title="No orders found"
          subtitle="There are no orders for the selected date range."
            emptyType={false ? "FILTERED" : "FRESH"}
          // showCreate={userRole !== "biller"} // 👈 permission control
          // onResetFilter={handleResetFilters}
          // onCreateOrder={() => navigate("/new-order")}
        />
      )}

      {/* Filters Drawer */}
      <OrderFilters
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        filters={filters}
        setFilters={setFilters}
        onApply={handleApply}
        onClear={handleClear}
      />

      <OrderDetailsDrawer
        isOpen={isOrderDetailsDrawerOpen}
        closeOrderDetailsDrawer={handleCloseOrderDetailsDrawer}
      />
    </Box>
  );
}
